import React from 'react';

const CovReportPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>COV Report Page</h3>
    </div>
  );
};

export default CovReportPage;
